import React from 'react';
import styles from './Project.module.scss';
import { AiFillGithub } from 'react-icons/ai';
import { BsBoxArrowUpRight } from 'react-icons/bs';

const Project = ({title, text, tec, img, code, demo, direction}) => {
    const image = require(`assets/${img}`)
    return (
        <div className={`${styles.project} ${direction && styles.inverted}`}>
            <div className={styles['image-container']}>
                <div>
                <img src={image} alt={title} />
                </div>
            </div>
            <div className={styles['text-container']}>
                <h2>{title}</h2>
                <p>{text}</p>
                <ul>
                    <li>React</li>
                    <li>{tec}</li>
                </ul>
                <div className={styles.links}>
                  {code && <a href={code} target="blank">Code<AiFillGithub /></a>}
                    <a href={demo} target="blank">Live Demo <BsBoxArrowUpRight /></a>
                </div>
            </div>
        </div>
    );
}

export default Project;
